import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const InfoContainer = styled.div`
  margin: 16px 0;

  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 24px;
  }
`

export const Name = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
`

export const ConfirmationText = styled.div`
  margin-top: -8px;
  margin-bottom: 16px;

  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.white};

  span {
    font-weight: ${theme.font.bold};
  }
`

interface IProps {
  invertColor?: boolean
}

export const ConfirmButton = styled.button<IProps>`
  width: 100%;
  background-color: ${({ invertColor }) => (invertColor ? theme.colors.white : theme.colors.green2)};
  border-radius: ${theme.border.mediumRadius};
  padding: 24px 0px;
  border: none;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${({ invertColor }) => (invertColor ? theme.colors.green2 : theme.colors.white)};

  @media (min-width: 768px) {
    width: 50%;
    margin: 0 auto;
  }
`
